<template id="Contato">
  <v-ons-page id="ContatoPage">
    <v-card class="Card_Contain d-flex justify-center">
      <div class="Card_Titulo">
        <h1>Contato</h1>
      </div>

      <div class="Container_Input" style="margin-top: 90px">
        <v-row>
          <span>Nome:</span>
          <v-text-field outlined v-model="c.dsNome" placeholder="Nome Completo*"></v-text-field>
        </v-row>

        <v-row>
          <span>Telefone:</span>
          <v-text-field outlined v-model="c.dsTelefone" placeholder="Telefone" v-mask="'(##) #####-####'"></v-text-field>
        </v-row>

        <v-row>
          <span>E-mail:</span>
          <v-text-field outlined v-model="c.dsEmail" placeholder="e-mail@dominio.com.br*" :rules="emailRules"></v-text-field>
        </v-row>

        <v-row>
          <span>Segmento:</span>
          <v-text-field outlined v-model="c.dsSegmento" placeholder="Segmento"></v-text-field>
        </v-row>

        <v-row>
          <span style="width: 100%; text-align: center;">Escreva abaixo sua dúvida ou solicitação:</span>
          <textarea
            class="textarea"
            rows="6"
            placeholder="Mensagem*"
            v-model="c.dsDuvida"
            style="margin: 10px auto; width: 100%;"
          >
          </textarea>
        </v-row>

        <v-row class="d-flex justify-center" style="margin-bottom: 30px">
          <v-ons-button class="botao" @click="enviarContato()">Enviar</v-ons-button>
        </v-row>
      </div>

    </v-card>

    <h3 class="copy">
      Copyright © 2020. Todos os direitos reservados a Cyma Digital.
      <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a>
    </h3>
  </v-ons-page>
</template>

<style scoped>
#ContatoPage {
  margin-left: 256px;
}
textarea {
  width: 80%;
  margin-top: 30px;
  background: #fff;
}
.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}

.Container_Input .row {
  width: 55vw;
  min-height: 70px;
  display: flex;
  align-items: baseline;
}

.Container_Input span {
  margin-right: 20px;
  text-transform: none;
  font-size: 1.2rem;
  color: #4d4d4d;
  width: 128px;
  text-align: right;
}

</style>
<script>
export default {
  name: "Contato",
  key: "Contato",
  props: ["activeIndex"],
  data() {
    return {
      icoMinhaLoja: "md-close",
      icoCardapio: "md-check",
      icoMesas: "md-close",
      icoFuncoes: "md-close",
      e: {},
      c: { dsNome: "", dsTelefone: "", dsEmail: "", dsDuvida: "" },
      busy: false,
      emailRules: [ 
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
    };
  },
  mounted() {
    var estab = localStorage.getItem("e");
    this.e = JSON.parse(estab);
    //window.console.log(this.e)
    if (
      this.e.dsNome != "" &&
      this.e.dsTelefone != "" &&
      this.e.dsEndereco != "" &&
      this.e.vlEnderecoNumero != "" &&
      this.e.dsBairro != "" &&
      this.e.idCidade != "" &&
      this.e.idEspecialidade != ""
    ) {
      this.icoMinhaLoja = "md-check";
    }
    if (this.e.arrMesas.length > 0) {
      this.icoMesas = "md-check";
    }
    if (
      this.e.flMostrarWifi != null &&
      this.e.flChamarGarcom != null &&
      this.e.flPedirConta != null &&
      this.e.flEnviarMsg != null
    ) {
      this.icoFuncoes = "md-check";
    }
  },
  methods: {
    openCardapio() {
      var w = window.open(
        this.$menu_base + "p/" + btoa(this.e.idEstabelecimento),
        "_blank"
      );
      w.focus();
    },
    enviarContato() {
      var error = "";
      if (this.c.dsNome == "") {
        error += "Por favor insira seu nome. ";
      }
      if (this.c.dsEmail == "") {
        error += "Por favor insira um email. ";
      }
      if (this.c.dsDuvida == "") {
        error += "Por favor insira uma mensagem. ";
      }
      if (error != "") {
        this.$ons.notification.toast(error, {
          timeout: 1000,
          animation: "ascend",
        });
        return;
      }
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(this.c.dsEmail)) {
        this.$ons.notification.toast("Por favor insira um EMAIL válido.", {
          timeout: 1000,
          animation: "ascend",
        });
      } else {
        this.showLoader();
        fetch(this.$menu_uri + "/enviar-contato", {
          method: "OPTIONS",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.c),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.send == true) {
              this.$ons.notification.toast("Contato enviado com sucesso.", {
                timeout: 3000,
                animation: "ascend",
              });
              this.showLoader();
              this.c = {
                dsNome: "",
                dsTelefone: "",
                dsEmail: "",
                dsDuvida: "",
                dsSegmento: "",
                idEstabelecimento: this.e.idEstabelecimento,
              };
            } else {
              this.$ons.notification.toast("Ocorreu um erro ao enviar o seu contato.", {
                timeout: 3000,
                animation: "ascend",
              });
              this.showLoader();
            }
          });
      }
    },
    showLoader() {
      this.busy = !this.busy;
    },
  },
};
</script>